import { createActions, createReducer } from 'reduxsauce'

import ClassificacaoService from '../servicos/ClassificacaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaClassificacaoInicio: [],
    buscaClassificacaoSucesso: ['classificacao'],
    buscaClassificacaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaClassificacao = () => {
    return dispatch => {
        dispatch(Creators.buscaClassificacaoInicio())
        let serv = new ClassificacaoService()
        return serv
            .getClassificacao()
            .then(response => dispatch(Creators.buscaClassificacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaClassificacaoErro(error)))
    }
}

const buscaClassificacaoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaClassificacaoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })
const buscaClassificacaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.classificacao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CLASSIFICACAO_INICIO]: buscaClassificacaoInicio,
    [Types.BUSCA_CLASSIFICACAO_ERRO]: buscaClassificacaoErro,
    [Types.BUSCA_CLASSIFICACAO_SUCESSO]: buscaClassificacaoSucesso,
})
